import React from 'react';
import ContentManager from './ContentManager';
import { getUSPs, createUSP, updateUSP, deleteUSP } from '../../api';

const USPs = () => {
  const fields = [
    { name: 'title', label: 'USP Title', type: 'text', required: true },
    { name: 'description', label: 'Description', type: 'textarea', rows: 3, required: true },
    { name: 'order', label: 'Display Order', type: 'number', defaultValue: 0 }
  ];

  return (
    <ContentManager
      title="USPs Management"
      itemLabel="USP"
      fields={fields}
      fetchFn={getUSPs}
      createFn={createUSP}
      updateFn={updateUSP}
      deleteFn={deleteUSP}
    />
  );
};

export default USPs;
